import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import store from 'redux/store';
import {
  GET_USER_CREDITS,
  GET_USER_CREDITS_SUCCESS,
  GET_USER_CREDITS_FAILED,
  GET_CREDIT_HISTORY_BY_NOTE,
  GET_CREDIT_HISTORY_BY_NOTE_SUCCESS,
  GET_CREDIT_HISTORY_BY_NOTE_FAILED,
  GET_ALL_USER_HAS_KAT_ADDRESS,
  GET_ALL_USER_HAS_KAT_ADDRESS_SUCCESS,
  GET_ALL_USER_HAS_KAT_ADDRESS_FAILED,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_SUCCESS,
  GET_EMAILS_BY_WALLET_ADDRESSES_IN_LP_SALE_FAILED,
  SEND_EMAIL_TO_DEV_PARTNER,
  SEND_EMAIL_TO_DEV_PARTNER_OK,
  SEND_EMAIL_TO_DEV_PARTNER_FAIL,
} from './actionTypes';

export const getCredits = (email) => {
  return async (dispatch) => {
    dispatch({ type: types.GET_CREDITS });

    client
      .api(`/credit/user-get-credits?email=${email}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        dispatch({
          type: types.GET_CREDITS_SUCCESS,
          data: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_CREDITS_FAILED,
          reason: err,
        });
      });
  };
};

export const getCreditsHistory = (limit, page) => {
  return async (dispatch) => {
    const credit = store.getState().credit;
    const { history, pagination } = credit;
    if (pagination.page === page) return;
    dispatch({ type: types.GET_CREDITS_HISTORY });

    client
      .api(`/credit/user-get-credits-history?limit=${limit}&page=${page}`, 'get', {
        headers: await cognito.getHeaderAuthorization(),
      })
      .then(({ data }) => {
        dispatch({
          type: types.GET_CREDITS_HISTORY_SUCCESS,
          data: {
            history: [...history, ...data.data],
            pagination: data.pagination,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_CREDITS_HISTORY_FAILED,
          reason: err,
        });
      });
  };
};

export const getUserCredits = (email) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_CREDITS });
    const response = await client.api(`/credit/user-get-credits?email=${email}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({
      type: GET_USER_CREDITS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_USER_CREDITS_FAILED,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const getCreditHistoryByNote = (note) => async (dispatch) => {
  try {
    dispatch({ type: GET_CREDIT_HISTORY_BY_NOTE });
    const response = await client.api(`/credit/user-get-credits-history-by-note?note=${note}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({
      type: GET_CREDIT_HISTORY_BY_NOTE_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_CREDIT_HISTORY_BY_NOTE_FAILED,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};
